import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {setMyProjects, setMyShareProjects} from '../../teach/reducers/teach';
import {getMyProjects} from '../../teach/api/project';
import {getClazz} from '../../teach/api/clazz';
import {setClazz} from '../../teach/reducers/teach';
import {getCourse} from '../../teach/api/course';
import {shareList} from '../../teach/api/share';

import Box from '../box/box.jsx';
import PlayButton from '../../containers/play-button.jsx';
import styles from './library-item.css';
import classNames from 'classnames';
import ProjectsDeleteModal from '../../teach/pages/projects/projects-delete-modal';
import CourceDeleteModal from '../../teach/pages/teacher-clazz/cource-delete-modal';
import ModalManager from '../../teach/components/modal/modal-manager';

import bluetoothIconURL from './bluetooth.svg';
import internetConnectionIconURL from './internet-connection.svg';
import gold from "./gold.png";

/* eslint-disable react/prefer-stateless-function */
class LibraryItemComponent extends React.PureComponent {
    constructor(props) {
        super(props)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleCourceDelete = this.handleCourceDelete.bind(this)
    }
    handleDelete(e) {
        e.stopPropagation();
        ModalManager.open(ProjectsDeleteModal, {
            closeAfterSubmit: true,
            onClose: () => {
                ModalManager.pop();
                if (this.props.projectType === 'myshare') {
                    shareList({page_size: 100}).then(res => this.props.setMyShareProjects(res));
                } else {
                    getMyProjects({page_size: 100}).then(res => this.props.setMyProjects(res));
                }
            },
            deleteId: this.props.projectId,
            projectType: this.props.projectType
        })
    }
    async handleCourceDelete(e) {
        e.stopPropagation();
        let obj = this.props.extensionId
        const index = obj.lastIndexOf("\&")
        const id = obj.substring(index + 1, obj.length).slice(3);
        const classId = obj.substring(0, index).slice(9);
        ModalManager.open(CourceDeleteModal, {
            closeAfterSubmit: true,
            onClose: () => {
                getClazz({id: classId}, {quiet: false}).then(res => {
                    this.props.setClazz(res);
                });
            },
            clazz_id: classId,
            course_id: id
        })
    }
    render() {
        return this.props.featured ? (
            <div
                style={{flexBasis: "274px"}}
                className={classNames(
                    styles.libraryItem,
                    styles.featuredItem,
                    {
                        [styles.disabled]: this.props.disabled
                    },
                    this.props.extensionId ? styles.libraryItemExtension : null,
                    this.props.hidden ? styles.hidden : null
                )}
                onClick={this.props.onClick}
            >
                {/* {
                    this.props.id > 0 && this.props.allowDelete &&
                    <div className={styles.deleteCircle} onClick={this.handleDelete}>x</div>
                } */}
                {
                    this.props.vip && (
                        <div className={styles.isVip}><img className={styles.vipPosition} src={gold}></img></div>
                    )
                }
                <div className={styles.featuredImageContainer}>
                    {(this.props.disabled || this.props.cornerText) ? (
                        <div className={styles.comingSoonText} style={this.props.cornerStyle}>
                            {this.props.cornerText ? (<span>{this.props.cornerText}</span>) : (
                                <FormattedMessage
                                    defaultMessage="Coming Soon"
                                    description="Label for extensions that are not yet implemented"
                                    id="gui.extensionLibrary.comingSoon"
                                />
                            )}
                        </div>
                    ) : null}
                    <img
                        style={{height: "203px"}}
                        className={styles.featuredImage}
                        src={this.props.iconURL}
                        onError={e => {e.target.onError = null;e.target.src="https://oss.pkcode.cn/scratch/cover/course/default.png"}}
                    />
                </div>
                {this.props.insetIconURL ? (
                    <div className={styles.libraryItemInsetImageContainer}>
                        <img
                            className={styles.libraryItemInsetImage}
                            src={this.props.insetIconURL}
                        />
                    </div>
                ) : null}
                <div
                    style={{width: "274px"}}
                    className={this.props.extensionId ?
                        classNames(styles.featuredExtensionText, styles.featuredText) : styles.featuredText
                    }
                >
                    <span className={styles.libraryItemName}>{this.props.name}</span>
                    <br />
                    <span className={styles.featuredDescription}>{this.props.description}</span>
                </div>
                {
                    this.props.extensionId && this.props.allowDelete &&
                    <span className={classNames(styles.deleteButton, styles.borderTop)} onClick={this.handleCourceDelete}>删除</span>
                }
                {!this.props.extensionId ? (
                    this.props.allowDelete ? (
                        this.props.projectId > 0 ? (
                            <span className={classNames(styles.deleteButton, styles.borderTop)} onClick={this.handleDelete}>删除</span>
                        ) : (
                            <span className={styles.deleteButton}></span>
                        )
                    ) : (null)
                ) : (null)}
                {this.props.bluetoothRequired || this.props.internetConnectionRequired || this.props.collaborator ? (
                    <div className={styles.featuredExtensionMetadata}>
                        <div className={styles.featuredExtensionRequirement}>
                            {this.props.bluetoothRequired || this.props.internetConnectionRequired ? (
                                <div>
                                    <div>
                                        <FormattedMessage
                                            defaultMessage="Requires"
                                            description="Label for extension hardware requirements"
                                            id="gui.extensionLibrary.requires"
                                        />
                                    </div>
                                    <div
                                        className={styles.featuredExtensionMetadataDetail}
                                    >
                                        {this.props.bluetoothRequired ? (
                                            <img src={bluetoothIconURL} />
                                        ) : null}
                                        {this.props.internetConnectionRequired ? (
                                            <img src={internetConnectionIconURL} />
                                        ) : null}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className={styles.featuredExtensionCollaboration}>
                            {this.props.collaborator ? (
                                <div>
                                    <div>
                                        <FormattedMessage
                                            defaultMessage="Collaboration with"
                                            description="Label for extension collaboration"
                                            id="gui.extensionLibrary.collaboration"
                                        />
                                    </div>
                                    <div
                                        className={styles.featuredExtensionMetadataDetail}
                                    >
                                        {this.props.collaborator}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                ) : null}
            </div>
        ) : (
            <Box
                className={classNames(
                    styles.libraryItem, {
                    [styles.hidden]: this.props.hidden
                }
                )}
                role="button"
                tabIndex="0"
                onBlur={this.props.onBlur}
                onClick={this.props.onClick}
                onFocus={this.props.onFocus}
                onKeyPress={this.props.onKeyPress}
                onMouseEnter={this.props.showPlayButton ? null : this.props.onMouseEnter}
                onMouseLeave={this.props.showPlayButton ? null : this.props.onMouseLeave}
            >
                {/* Layers of wrapping is to prevent layout thrashing on animation */}
                <Box className={styles.libraryItemImageContainerWrapper}>
                    <Box
                        className={styles.libraryItemImageContainer}
                        onMouseEnter={this.props.showPlayButton ? this.props.onMouseEnter : null}
                        onMouseLeave={this.props.showPlayButton ? this.props.onMouseLeave : null}
                    >
                        <img
                            className={styles.libraryItemImage}
                            src={this.props.iconURL}
                        />
                    </Box>
                </Box>
                <span className={styles.libraryItemName}>{this.props.name}</span>
                {this.props.showPlayButton ? (
                    <PlayButton
                        isPlaying={this.props.isPlaying}
                        onPlay={this.props.onPlay}
                        onStop={this.props.onStop}
                    />
                ) : null}
            </Box>
        );
    }
}
/* eslint-enable react/prefer-stateless-function */


LibraryItemComponent.propTypes = {
    projectId: PropTypes.number,
    allowDelete: PropTypes.bool,
    bluetoothRequired: PropTypes.bool,
    collaborator: PropTypes.string,
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    disabled: PropTypes.bool,
    cornerText: PropTypes.string,
    cornerStyle: PropTypes.object,
    extensionId: PropTypes.string,
    featured: PropTypes.bool,
    hidden: PropTypes.bool,
    iconURL: PropTypes.string,
    insetIconURL: PropTypes.string,
    internetConnectionRequired: PropTypes.bool,
    isPlaying: PropTypes.bool,
    name: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    onBlur: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    onPlay: PropTypes.func.isRequired,
    onStop: PropTypes.func.isRequired,
    showPlayButton: PropTypes.bool
};

LibraryItemComponent.defaultProps = {
    disabled: false,
    showPlayButton: false
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    setMyProjects: projects => dispatch(setMyProjects(projects)),
    setMyShareProjects: projects => dispatch(setMyShareProjects(projects)),
    setClazz: res => dispatch(setClazz(res)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LibraryItemComponent);
